import React from 'react';
import Helmet from 'react-helmet';

const SchoolRejected = () => (
    <div className="container" style={{ padding: '80px 0' }}>
        <Helmet title="Account Rejected" />
        <div className="ui icon message">
            <i className="warning sign icon" />
            <div className="content">
                <div className="header">
                    Account rejected
                </div>
                <p>Sorry, we weren’t able to verify that you were a UK primary school. Please register again using your school email address.</p>
            </div>
        </div>
    </div>
);

export default SchoolRejected;



/** WEBPACK FOOTER **
 ** ./src/pages/SchoolRejected.js
 **/